import {localStorageGet} from "./storage";
import * as Yup from 'yup';
//import { ConsoleLogger } from "@aws-amplify/core";

const formatDate = (inputDate: string) => {
  const [dd, mm, yyyy] = (inputDate).split('/');
  return yyyy + '-' + mm + '-' + dd;
}

const formatDateScript = (inputDate: string) => {
  const [yyyy, mm, dd ] = (inputDate).split('-');
  return dd + '/' + mm  + '/' + yyyy ;
}

const formatAmount = (num: number): string => {
  const formatted = num.toLocaleString('en', {minimumFractionDigits: 0})

  return formatted.split(',').length > 2
    ? `${formatted.split(',')[0]}'${formatted.split(',')[1]},${formatted.split(',')[2]}`
    : formatted
}

const lessOneRol = (rolesCognito: any): any => {
  const suscriptorRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_SUSCRIPTOR_JEFE || obj === process.env.REACT_APP_ROL_SUSCRIPTOR_ANALISTA || obj === process.env.REACT_APP_ROL_SUSCRIPTOR_MEDICO;
  });
  const supervisorRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_SUPERVISOR;
  });
  const cobranzaRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_COBRANZA;
  });
  const consultasRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_CONSULTAS;
  });
  const emisorRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_EMISOR;
  });
  const supervisorAgenciaRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_SUPERVISOR_AGENCIA;
  });
  const asesorRol = rolesCognito.filter((obj: any) => {
    return obj === process.env.REACT_APP_ROL_ASESOR;
  });
  if (suscriptorRol.length > 0) { return suscriptorRol; }
  if (supervisorRol.length > 0) { return supervisorRol; }
  if (cobranzaRol.length > 0) { return cobranzaRol; }
  if (consultasRol.length > 0) { return consultasRol; }
  if (emisorRol.length > 0) { return emisorRol; }
  if (supervisorAgenciaRol.length > 0) { return supervisorAgenciaRol; }
  if (asesorRol.length > 0) { return asesorRol; }
  return rolesCognito;
}

const toCommaNumber = ( num:any ) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const formatAmountCurrency = (num: number, currency?: string) => {
  const formatted = num? num.toFixed(2) : 0;
  const amountSymbol = (currency === 'PEN') ? 'S/ ' : '$ ';
  const value = currency? (amountSymbol + formatted) : formatted;
  return toCommaNumber(value);
}

const formatNumber = (num: number): string => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

const getAge = (pBorndate: string): number => {
  const borndate: any = new Date(pBorndate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"));
  const ageDate = new Date(Date.now() - borndate);
  const age = Math.abs(ageDate.getFullYear() - 1970);
  return age ? age : 0;
}

const getActuarialAge = (pBorndate: string): number => {
  const birthday_arr = pBorndate.split('/');
  const birthday_date = new Date(parseInt(birthday_arr[2]), parseInt(birthday_arr[1]) - 1, parseInt(birthday_arr[0]));
  return Math.round(((+new Date()) - (+birthday_date)) / 1000 / 60 / 60 / 24 / 365.25);
}

const dateToString = (vdate: string) => {
  var date = new Date(formatDate(vdate));
  date.setDate(date.getDate() + 1);
  let options = {weekday: 'long', day: 'numeric', month: 'long'};
  return date.toLocaleDateString("es-ES", options);
}

const formatHour = (vdate: string, vhour: string) => {
  var date = new Date(formatDate(vdate) + ' ' + vhour);
  return date.toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'});
}

const getFullElementHeight = (elem: any, parent?: any) => {
  const root = (parent === undefined) ? document : parent;
  elem = (typeof elem === 'string') ? root.querySelector(elem) : elem;

  let styles = getComputedStyle(elem),
    margin = parseFloat(styles['marginTop'] || '') + parseFloat(styles['marginBottom'] || '');

  return Math.ceil(elem.offsetHeight + margin);
}

const toQueryString = (params: any) => {
  const query = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  return query;
};

const hasUniquevaluesInlist = (list: any, key: any, check_values: any) => {
  let lista = list.map((i: any) => Number(i[key]));
  let uniq = lista.map((name: any) => {
    return {count: 1, name: name}
  }).reduce((a: any, b: any) => {
    a[b.name] = (a[b.name] || 0) + b.count;
    return a
  }, {});
  return check_values.filter((i: any) => i in uniq ? uniq[i] > 1 : false).length > 0;
};

const getUniqueArrayByAttribute = (arr:Array<object>, key:string) => {
  let a:Array<string> = [];
  arr.forEach((item:any)=>{
      let current = item[`${key}`];
      if (a.indexOf(current) < 0) a.push(current);
  })
  return a;
}

export const numberWithCommas = (value: any) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const getPayment = (pSumaAsegurada: number, pPaymentAnnual: number, pBaseprice: number, pMonthlyFactor: number, pActuarialAge: number = 0): string => {
  const year = (pMonthlyFactor === 65 ? pMonthlyFactor - pActuarialAge : pMonthlyFactor);
  const value: number = ((pSumaAsegurada * pPaymentAnnual) / pBaseprice) * 1.03 * year;
  return value.toFixed(2);
};

const getFirstName = (text: string = '') => {
  const name = text.split(' ')[0];
  return name.substr(0, 1).toUpperCase() + name.substr(1).toLowerCase();
}

const setCapitalizeName = (text: string = '') => {
  return text.toLowerCase().replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() });
};

const getImc = (height: number, weight: number): number => {
  return Math.round(weight * 100 / (height * height / 10000)) / 100;
};

const round = (number: number) => Math.round(number * 100) / 100;

const roundInteger = (number: number) => Math.round(number * 1) / 1;

const hasErrors = (errors:any):any => {
  return Object.keys(errors).some(key => {
    const value = errors[key];

    if (value && typeof value === 'object') {
      return hasErrors(value)
    }
    return typeof value !== 'undefined'
  })
};

const transformFunction = (list : []) => {
  let engine : any = { };
  let parameters : any = { };

  list.map((item : any) => {
    if(Number(item.descripcion)){
      parameters[item.codigo] = Number(item.descripcion)
    } else {
      let [form, inputs] = item.descripcion.split('||');
      engine[item.codigo] = {
        inputs,
        body : 'return ' + form
      }
      return false;
    }
  })

  return {
    engine,
    parameters
  };
}

const toFunction = (engine: any) => {
  const {inputs = undefined, body = undefined} = engine;
  return Function(inputs, body);
};

const getRoleAsesor = () => {
  let ls_role = localStorageGet('rimac_user_info').listacodext.filter((item: any) => item.idtipo === 8);
  return ls_role.length > 0 ? ls_role[0].idexterno : 2; 
};

const getFlagFVAsesor = () => {
  let ls_fv = localStorageGet('rimac_user_info').listacodext.filter((item: any) => item.idtipo === 9);
  return ls_fv.length > 0 ? Number(ls_fv[0].idexterno) : 0;
};

const lifeExpectancy = (pAge: any, pExpectancy: any = [], pSex: string) => {
  const age = Math.floor(pAge / 5 ) * 5;
  const lifeExpectancy = pExpectancy[pSex];
  const ageExpectancy = lifeExpectancy.filter( (item: any) => item.codigo === age);
  return ageExpectancy? (ageExpectancy.length> 0? Number(ageExpectancy[0].descripcion) : 0) : 0;
};

const toCapitalize = (text: any) => {
  if (typeof text !== 'string') return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const toSpace = (text: string = '') => {
  const traducedString = text.replace(/([A-Z])/g, ' $1').trim().toLowerCase()
  return toCapitalize(traducedString)
}
const getSiblings = (elem:any) => {
  let siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
      if (sibling.nodeType !== 1 || sibling === elem) continue;
      siblings.push(sibling);
  }
  return siblings;
};

const addDayToDate = ( pDate:any, day:any ) => {

  const from = pDate.split("-");
  let date = new Date( from[0], from[1] - 1, from[2] );
  date = new Date(date.setDate(date.getDate() + day));
  
  let dayOfMonth, month;
  if (date.getDate() < 10) {
    dayOfMonth = '0' + `${date.getDate()}`;
  } else {
    dayOfMonth = `${date.getDate()}`;
  }
  if (date.getMonth() + 1 < 10) {
    month = '0' + `${date.getMonth() + 1}`;
  } else {
    month = `${date.getMonth() + 1}`;
  }

  return dayOfMonth + '/' + month + '/' + date.getFullYear();
  
}

const getActuallyDate = () => {
  let dateActual = new Date();
  let datestring = dateActual.getFullYear() + "/" + ("0"+(dateActual.getMonth()+1)).slice(-2) + "/" + ("0" + dateActual.getDate()).slice(-2) + "|" +
   ("0" + dateActual.getHours()).slice(-2) + ":" + ("0" + dateActual.getMinutes()).slice(-2) + ":" + ("0" + dateActual.getSeconds()).slice(-2);
   return datestring;
}

const obtenerHoraMinSeg = () => {
  let today = new Date();
  const hours = today.getHours().toString().length === 1 ? '0' + today.getHours() : today.getHours();
  const minutes = today.getMinutes().toString().length === 1 ? '0' + today.getMinutes() : today.getMinutes();
  const seconds = today.getSeconds().toString().length === 1 ? '0' + today.getSeconds() : today.getSeconds();
  return {
    hora: hours,
    minutos: minutes,
    segundos: seconds
  };
}

const obtenerAnioMesDia = () => {
  let today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().length === 1 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1);
  const date = today.getDate().toString().length === 1 ? '0' + today.getDate() : today.getDate();
  return {
    anio: year,
    mes: month,
    dia: date
  };
}

const generarRequest = (params: any, trace: any) => {
  const fecha = obtenerAnioMesDia();
  const tiempo = obtenerHoraMinSeg();
  let req = {
    request: {
      trace: {
        
        serviceId: trace ? (trace.serviceId ? trace.serviceId : 'API-LISTAR-SOLICITUD') : 'API-LISTAR-SOLICITUD',
        consumerId: trace ? (trace.consumerId ? trace.consumerId : 'MYWORKSITE') : 'MYWORKSITE',
        channelCode: trace ? (trace.channelCode ? trace.channelCode : 'WEB') : 'WEB',
        traceId: new Date().getTime(),
        timestamp: fecha.dia + "/" + fecha.mes + "/" + fecha.anio + " " + tiempo.hora + ":" + tiempo.minutos + ":" + tiempo.segundos,
        identity: {
          userId: trace ? (trace.consumerId ? trace.consumerId : 'MYWORKSITE') : 'MYWORKSITE',
          deviceId: 'WEB'
        }
      },
      payload: params
    }
  }
  return req;
}

const responseVacioSolicitudes = () => {
  const res = {
    "paginacion":{
      "page":0,
      "size":0,
      "total":0
    },
    "contenido":[]
  };
  return res;
}

const getAmplifyToSeguridadRequest = (user: any) => {
  return {
    idApplication: user['aud'],
    cognitoGroups: user['cognito:groups'],
    userName: user['cognito:username'],
    email: user['email'],
    nombre: user['name'],
    apellidos: user['family_name'],
    configuredGroups: [
      process.env.REACT_APP_ROL_EMISOR, process.env.REACT_APP_ROL_ASESOR, process.env.REACT_APP_ROL_SUPERVISOR, process.env.REACT_APP_ROL_CONSULTAS, process.env.REACT_APP_ROL_COBRANZA
    ]
  }
}

const validateFilterSolicitud = () => {
  return Yup.object().shape({
      isearch: Yup.string()
      .min(2, 'Longitud no valida')
      .max(50, 'Longitud demasiado larga'),
    initRangeDate:Yup.date()
    .test('range-general', 'Los rangos de fechas debe de estar llenos' , function (value){
        if(this.parent.endRangeDat){
          if(!value){
            
            return false
          }
          return true
        }
        return true
      }),
    endRangeDate: Yup.date()
      .test('range-validation', 'Los rangos de fechas debe de estar llenos', function(value) {
        if(this.parent.initRangeDate && !value){
          console.log("Entra aca")
          return false
        }else{
          return true 
        }
      }).test('range-general', 'Los rangos de fechas debe de estar llenos' , function (value){
        if(this.parent.initRangeDate){
          if(!value){
            
            return false
          }
          return true
        }
        return true
      }).test('range-validation-concordance', 'La fecha de inicio debe ser menor que la fecha fin', function(value) {
        if(this.parent.initRangeDate && value){
          if(value.getTime() - this.parent.initRangeDate.getTime() >0 ){
            return true
          }
          return false
        }
        return true
      })
    });
  }

  const validateFilterDistribucion = () => {
    return Yup.object().shape({
      isearchruc: Yup.string()
        .min(2, 'Longitud no valida')
        .max(50, 'Longitud demasiado larga'),
      isearch: Yup.string()
        .min(2, 'Longitud no valida')
        .max(50, 'Longitud demasiado larga'),
      initRangeDate:Yup.date()
      .test('range-general', 'Los rangos de fechas debe de estar llenos' , function (value){
          console.log("Entra aca range-validation-init", value)
          console.log("Entra aca range-validation this.parent.endRangeDate", this.parent.endRangeDate)
          if(this.parent.endRangeDat){
            if(!value){
              
              return false
            }
            return true
          }
          return true
        }),
      endRangeDate: Yup.date()
        .test('range-validation', 'Los rangos de fechas debe de estar llenos', function(value) {
          if(this.parent.initRangeDate && !value){
            console.log("Entra aca")
            return false
          }else{
            return true 
          }
        }).test('range-general', 'Los rangos de fechas debe de estar llenos' , function (value){
          console.log("Entra aca range-validation-init", value)
          console.log("Entra aca range-validation this.parent.endRangeDate", this.parent.endRangeDate)
          if(this.parent.initRangeDate){
            if(!value){
              
              return false
            }
            return true
          }
          return true
        }).test('range-validation-concordance', 'La fecha de inicio debe ser menor que la fecha fin', function(value) {
          if(this.parent.initRangeDate && value){
            if(value.getTime() - this.parent.initRangeDate.getTime() >0 ){
              return true
            }
            return false
          }
          return true
        })
    });
    }

  const validateFilterAutorizacion = () => {
    return Yup.object().shape({
      iSearchValueDoc: Yup.string()
        // .matches(/^[0-9]*$/, 'Deben ser sólo números')
        .min(2, 'Longitud no válida')
        .max(50, 'Longitud demasiado larga')
        .test('not-null-tipodoc', 'Valor no válido', function(value : any) {
          if(this.parent.iSearchCombo && (value === undefined || value === '')){
            return false;
          }else{
            return true;
          }
        }),
      iSearchSubVia: Yup.string()
        .matches(/^[0-9]*$/, 'Deben ser sólo números')
        .max(3, 'Longitud demasiado larga')
        .test('via-validation', 'Debe ingresar una vía', function(value : any) {
          if(!this.parent.iSearchValueDoc && value){
            return false;
          }else{
            return true;
          }
        })
    });
    }
    const getAliasMoneda = (moneda: string) => {
      let alias_moneda = '';
      switch (moneda) {
        case 'PEN':
          alias_moneda = 'S/.' 
          break;
        case 'USD':
          alias_moneda = '$' 
          break;
        default:
          alias_moneda = moneda;
          break;
      }
      return alias_moneda;
    }

export default {
  formatDate,
  getFullElementHeight,
  dateToString,
  formatHour,
  formatAmountCurrency,
  hasUniquevaluesInlist,
  getUniqueArrayByAttribute,
  getAge,
  getActuarialAge,
  formatNumber,
  toQueryString,
  numberWithCommas,
  getPayment,
  formatAmount,
  lessOneRol,
  getFirstName,
  setCapitalizeName,
  getImc,
  round,
  roundInteger,
  hasErrors,
  transformFunction,
  toFunction,
  lifeExpectancy,
  getRoleAsesor,
  getFlagFVAsesor,
  toCapitalize,
  toSpace,
  getSiblings,
  addDayToDate,
  formatDateScript,
  getActuallyDate,
  obtenerHoraMinSeg,
  obtenerAnioMesDia,
  generarRequest,
  responseVacioSolicitudes,
  getAmplifyToSeguridadRequest,
  validateFilterSolicitud,
  validateFilterDistribucion,
  validateFilterAutorizacion,
  getAliasMoneda
}
